import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.7"
        d="M11.5828 10.4367L8.17374 15.4367C7.94205 15.7766 7.94205 16.2236 8.17374 16.5634L11.5828 21.5634C11.894 22.0197 12.5161 22.1374 12.9724 21.8263C13.4287 21.5152 13.5464 20.8931 13.2353 20.4367L10.2592 16.0002L13.2353 11.5634C13.5464 11.1071 13.4287 10.485 12.9724 10.1739C12.5161 9.86274 11.894 9.98044 11.5828 10.4367Z"
        fill="#101010"
      />
      <path
        opacity="0.4"
        d="M17.5828 10.4367L14.1737 15.4367C13.942 15.7766 13.942 16.2236 14.1737 16.5634L17.5828 21.5634C17.894 22.0197 18.5161 22.1374 18.9724 21.8263C19.4287 21.5152 19.5464 20.8931 19.2353 20.4367L16.2592 16.0002L19.2353 11.5634C19.5464 11.1071 19.4287 10.485 18.9724 10.1739C18.5161 9.86274 17.894 9.98044 17.5828 10.4367Z"
        fill="#101010"
      />
      <path
        opacity="0.2"
        d="M23.5828 10.4367L20.1737 15.4367C19.942 15.7766 19.942 16.2236 20.1737 16.5634L23.5828 21.5634C23.894 22.0197 24.5161 22.1374 24.9724 21.8263C25.4287 21.5152 25.5464 20.8931 25.2353 20.4367L22.2592 16.0002L25.2353 11.5634C25.5464 11.1071 25.4287 10.485 24.9724 10.1739C24.5161 9.86274 23.894 9.98044 23.5828 10.4367Z"
        fill="#101010"
      />
      <path
        opacity="0.1"
        d="M29.5828 10.4367L26.1737 15.4367C25.942 15.7766 25.942 16.2236 26.1737 16.5634L29.5828 21.5634C29.894 22.0197 30.5161 22.1374 30.9724 21.8263C31.4287 21.5152 31.5464 20.8931 31.2353 20.4367L28.2592 16.0002L31.2353 11.5634C31.5464 11.1071 31.4287 10.485 30.9724 10.1739C30.5161 9.86274 29.894 9.98044 29.5828 10.4367Z"
        fill="#101010"
      />
      <path
        d="M5.58284 10.4367L2.17374 15.4367C1.94205 15.7766 1.94205 16.2236 2.17374 16.5634L5.58284 21.5634C5.89396 22.0197 6.51609 22.1374 6.9724 21.8263C7.42871 21.5152 7.54641 20.8931 7.23529 20.4367L4.25918 16.0002L7.23529 11.5634C7.54641 11.1071 7.42871 10.485 6.9724 10.1739C6.51609 9.86274 5.89396 9.98044 5.58284 10.4367Z"
        fill="#101010"
      />
    </svg>
  );
};

export default Svg;
